/**
 * Appends the input digit to the end of the input number
 */
export function appendDigit(value: number, digit: string, fractionDigits = 2): number {
  const intValue = value * Math.pow(10, fractionDigits)
  const newIntValue = intValue * 10 + parseInt(digit, 10)
  return newIntValue / Math.pow(10, fractionDigits)
}

/**
 * Removes one character from the right side of the input number
 */
export function removeDigit(value: number, fractionDigits = 2): number {
  const fixed = value.toFixed(fractionDigits)
  const minorStr = fixed.replace('.', '')
  let minor = Number(minorStr || '0')
  if (fractionDigits > 0) minor = Number(minorStr || '0') / 10
  const denominator = 10 ** fractionDigits
  const result = Number(minor) / denominator
  return result
}
